<!-- Header -->
<div class="card-header card-header-grid">
  <!-- Search -->
  <div class="input-group input-lined" role="search">
    <div class="input-group-text">
      <i role="img" class="fa fa-filter text-muted" aria-hidden="true"></i>
    </div>
    <input
      class="form-control"
      type="text"
      placeholder="{{ 'general.filter' | translate }}"
      attr.aria-label="{{ 'general.filter' | translate }}"
      [(ngModel)]="filterTerm"
    />
  </div>
  <!-- End Search -->

  <div class="d-flex justify-content-end align-items-center">
    <div class="">
      <span>
        {{ (tableData | recursiveFilter: filterTerm)?.length }}
        {{ 'general.total' | translate }}
      </span>
    </div>

    <div
      class="btn-group ms-3"
      dropdown
      *ngIf="bulkActions?.length"
      [canSee]="[accessRights.OperationInternalEvents_delete]"
    >
      <button
        class="btn btn-sm btn-white dropdown-toggle"
        type="button"
        dropdownToggle
        aria-controls="bulkAction2"
      >
        {{ 'general.bulkActions' | translate }}
      </button>

      <ul
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        id="bulkAction2"
      >
        <li *ngFor="let bulkAction of bulkActions">
          <a
            class="dropdown-item"
            href="javascript:;"
            (click)="onClickBulkAction(bulkAction)"
          >
            {{ 'general.' + bulkAction | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- End Row -->
</div>
<!-- End Header -->

<!-- Table -->
<div class="table-responsive">
  <table
    class="table table-borderless table-striped table-hover table-nowrap"
    [mfData]="tableData | recursiveFilter: filterTerm"
    #dataTable="mfDataTable"
    [mfRowsOnPage]="25"
  >
    <thead class="table-light">
      <tr>
        <th
          scope="col"
          (click)="onToggleAllChecked()"
          class="cursor-pointer"
          style="max-width: 60px"
        >
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="allCheckedToggle"
            attr.aria-label="{{ 'general.selectAll' | translate }}"
          />
        </th>
        <th scope="col" style="width: 30%">
          <mfDefaultSorter by="internalEventId">
            {{ 'general.event' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 30%">
          <mfDefaultSorter by="surveyId">
            {{ 'surveyModule.survey' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 40%">
          <mfDefaultSorter by="parent">
            {{ 'general.parent' | translate }}
          </mfDefaultSorter>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of dataTable.data; let i = index"
        class="cursor-pointer"
      >
        <td (click)="onCheckRow(item)" class="cursor-pointer">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="this.checkedIds.get(item.id)"
            attr.aria-label="{{ 'wcag.selectThis' | translate }}"
          />
        </td>
        <td
          (click)="onRowClicked(item)"
          (keyup.enter)="onRowClicked(item)"
          tabindex="0"
          role="link"
        >
          {{
            internalEventTypesArray[
              (internalEventEntities$ | async)[item.internalEventId]?.type
            ]
          }}
        </td>
        <td (click)="onRowClicked(item)">
          {{ (surveyEntities$ | async)[item.surveyId]?.name }}
        </td>
        <td (click)="onRowClicked(item)">
          <span class="badge rounded-pill bg-primary" *ngIf="item.productId">
            {{ 'productModule.product' | translate }}
            -
            {{ (productEntities$ | async)[item.productId]?.description }}
          </span>
          <span
            class="badge rounded-pill bg-primary"
            *ngIf="item.subscriptionId"
          >
            {{ 'subscriptionModule.subscription' | translate }}
            -
            {{
              (subscriptionEntities$ | async)[item.subscriptionId]?.description
            }}
          </span>
          <span class="badge rounded-pill bg-primary" *ngIf="item.courseId">
            {{ 'courseModule.course' | translate }} -
            {{ (courseEntities$ | async)[item.courseId]?.description }}
          </span>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="6" class="pb-0">
          <mfBootstrapPaginator
            [rowsOnPageSet]="[25, 50, 100]"
          ></mfBootstrapPaginator>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
